module.exports = __webpack_public_path__ + "static/saldo-07da518644a5476c2671834fdeea3d28.jpg";